import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.svg'
import _imports_1 from '@/assets/forgot-password.svg'


const _withScopeId = n => (_pushScopeId("data-v-1ca9cebe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar navbar-expand-md navbar-light bg-white sticky-top" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "navbar-brand",
  href: "#"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "header-logo",
    src: _imports_0,
    alt: "logo"
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-toggle": "collapse",
  "data-target": "#navbarSupportedContent",
  "aria-controls": "navbarSupportedContent",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1))
const _hoisted_5 = {
  class: "collapse navbar-collapse",
  id: "navbarSupportedContent"
}
const _hoisted_6 = { class: "navbar-nav ml-auto" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "nav-link",
    "aria-current": "page",
    href: "https://www.redcastletechnology.com/"
  }, "Home")
], -1))
const _hoisted_8 = { class: "nav-item active" }
const _hoisted_9 = { class: "nav-item active" }
const _hoisted_10 = { class: "d-flex align-items-center my-6" }
const _hoisted_11 = { class: "custom-container" }
const _hoisted_12 = { class: "my-lg-5 my-md-7" }
const _hoisted_13 = { class: "row align-items-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col col-lg-6 d-none d-lg-block text-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "Forgot password illustration"
  })
], -1))
const _hoisted_15 = { class: "col col-md-9 col-lg-6 mx-auto" }
const _hoisted_16 = { class: "card shadow-sm" }
const _hoisted_17 = { class: "card-body" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pb-3 mb-4 border-bottom" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "h4 mb-1" }, "Almost Done!"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, " Set up a new password ")
], -1))
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "New Password", -1))
const _hoisted_21 = {
  key: 0,
  class: "pt-1"
}
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Confirm Password", -1))
const _hoisted_24 = { class: "form-check d-flex align-items-center px-1 mt-2 ml-0" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "my-0 cursor-pointer text-muted",
  for: "defaultCheck1"
}, " Show Password ", -1))
const _hoisted_26 = { class: "row mt-4 justify-content-center" }
const _hoisted_27 = { class: "col-sm-12 col-md-8" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-weight-bold" }, "Save", -1))
const _hoisted_30 = { class: "spinner-border spinner-border-sm" }
const _hoisted_31 = { class: "row mt-4" }
const _hoisted_32 = { class: "col" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { class: "font-weight-bold" }
const _hoisted_35 = {
  key: 1,
  class: "alert alert-danger",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_input_field = _resolveComponent("input-field")!
  const _component_Form = _resolveComponent("Form")!
  const _component_footer_component = _resolveComponent("footer-component")!
  const _component_ConfirmationModal = _resolveComponent("ConfirmationModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("ul", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("li", _hoisted_8, [
              _createElementVNode("a", {
                class: "btn btn-primary-dark py-2 ml-3 font-weight-bold",
                href: "#",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.register && _ctx.register(...args)))
              }, "Create Account")
            ]),
            _createElementVNode("li", _hoisted_9, [
              _createVNode(_component_router_link, {
                class: "btn btn-outline-primary-dark py-2 ml-3 font-weight-bold",
                to: { name: 'login' }
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Login")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createVNode(_component_Form, {
                    onSubmit: _ctx.changePassword,
                    "validation-schema": _ctx.schema
                  }, {
                    default: _withCtx((meta) => [
                      _createElementVNode("div", _hoisted_19, [
                        _hoisted_20,
                        _createVNode(_component_input_field, { icon: "key" }, {
                          input: _withCtx(() => [
                            _createVNode(_component_Field, {
                              type: `${_ctx.showPassword ? 'text' : 'password'}`,
                              name: "newPassword",
                              placeholder: "Password",
                              modelValue: _ctx.newPassword,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newPassword) = $event)),
                              onInput: _ctx.checkPassword,
                              class: _normalizeClass(meta.errors.newPassword ? 'is-invalid' : '')
                            }, null, 8, ["type", "modelValue", "onInput", "class"]),
                            _createVNode(_component_ErrorMessage, {
                              name: "newPassword",
                              class: "invalid-feedback"
                            }),
                            (_ctx.newPassword)
                              ? (_openBlock(), _createElementBlock("small", _hoisted_21, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(`d-block ${
                              _ctx.contains_eight_characters
                                ? 'text-success'
                                : 'text-muted'
                            }`)
                                  }, [
                                    _createTextVNode(" - Minimum 8 characters "),
                                    (_ctx.contains_eight_characters)
                                      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                          key: 0,
                                          class: "ml-1 text-success",
                                          icon: "check-circle"
                                        }))
                                      : _createCommentVNode("", true)
                                  ], 2),
                                  _createElementVNode("span", {
                                    class: _normalizeClass(`d-block ${
                              _ctx.contains_number ? 'text-success' : 'text-muted'
                            }`)
                                  }, [
                                    _createTextVNode(" - Contains number "),
                                    (_ctx.contains_number)
                                      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                          key: 0,
                                          class: "ml-1 text-success",
                                          icon: "check-circle"
                                        }))
                                      : _createCommentVNode("", true)
                                  ], 2),
                                  _createElementVNode("span", {
                                    class: _normalizeClass(`d-block ${
                              _ctx.contains_uppercase ? 'text-success' : 'text-muted'
                            }`)
                                  }, [
                                    _createTextVNode(" - Contains uppercase "),
                                    (_ctx.contains_uppercase)
                                      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                          key: 0,
                                          class: "ml-1 text-success",
                                          icon: "check-circle"
                                        }))
                                      : _createCommentVNode("", true)
                                  ], 2),
                                  _createElementVNode("span", {
                                    class: _normalizeClass(`d-block ${
                              _ctx.contains_lowercase ? 'text-success' : 'text-muted'
                            }`)
                                  }, [
                                    _createTextVNode(" - Contains lowercase "),
                                    (_ctx.contains_lowercase)
                                      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                          key: 0,
                                          class: "ml-1 text-success",
                                          icon: "check-circle"
                                        }))
                                      : _createCommentVNode("", true)
                                  ], 2),
                                  _createElementVNode("span", {
                                    class: _normalizeClass(`d-block ${
                              _ctx.contains_special_character
                                ? 'text-success'
                                : 'text-muted'
                            }`)
                                  }, [
                                    _createTextVNode(" - Contains special character "),
                                    (_ctx.contains_special_character)
                                      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                          key: 0,
                                          class: "ml-1 text-success",
                                          icon: "check-circle"
                                        }))
                                      : _createCommentVNode("", true)
                                  ], 2)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _hoisted_23,
                        _createVNode(_component_input_field, { icon: "key" }, {
                          input: _withCtx(() => [
                            _createVNode(_component_Field, {
                              type: `${_ctx.showPassword ? 'text' : 'password'}`,
                              name: "confirmPassword",
                              placeholder: "Confirm Password",
                              class: _normalizeClass(
                            meta.errors.confirmPassword ? 'is-invalid' : ''
                          )
                            }, null, 8, ["type", "class"]),
                            _createVNode(_component_ErrorMessage, {
                              name: "confirmPassword",
                              class: "invalid-feedback"
                            })
                          ]),
                          _: 2
                        }, 1024),
                        _createElementVNode("div", _hoisted_24, [
                          _withDirectives(_createElementVNode("input", {
                            class: "cus-checkbox m-0 mr-2",
                            type: "checkbox",
                            value: "true",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showPassword) = $event)),
                            id: "defaultCheck1"
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.showPassword]
                          ]),
                          _hoisted_25
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("button", {
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.register && _ctx.register(...args))),
                            class: "btn-primary btn-lg-cus",
                            disabled: _ctx.loading
                          }, [
                            _hoisted_29,
                            _withDirectives(_createElementVNode("span", _hoisted_30, null, 512), [
                              [_vShow, _ctx.loading]
                            ])
                          ], 8, _hoisted_28)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          (_ctx.message.errors)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.message.errors, (msg, key, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "alert alert-danger",
                                    role: "alert",
                                    key: index
                                  }, [
                                    _createElementVNode("span", _hoisted_34, _toDisplayString(key) + ": ", 1),
                                    _createTextVNode(" " + _toDisplayString(msg[0]), 1)
                                  ]))
                                }), 128))
                              ]))
                            : (_ctx.message)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(_ctx.message), 1))
                              : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["onSubmit", "validation-schema"])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_footer_component),
    _createVNode(_component_ConfirmationModal, { ref: "confirmDialogue" }, null, 512)
  ], 64))
}